import { ParentState } from "@hopper-b2b/checkout";
import type { State } from "xstate";
import type { ParentContextWithRewardsPayment } from "./types";

type CommonStateType = State<ParentContextWithRewardsPayment>;
type CommonStateWithoutValue = Pick<CommonStateType, "context">;

export const getState = (state: CommonStateWithoutValue) => state;

export const getRewardsSelectedState = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].rewardsSelectedState;

export const getRewardsAmountToApply = (state: CommonStateWithoutValue) => {
  return state.context[ParentState.awardsPayment].rewardsAmountToApply;
};

export const getRewardsAmountToApplyCashEquivalent = (
  state: CommonStateWithoutValue
) => {
  return state.context[ParentState.awardsPayment]
    .rewardsAmountToApplyCashEquivalent;
};

export const getAdditionalPointsPurchase = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].additionalPointsPurchase;

export const getRewardsAccountId = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].rewardsAccountId;

export const getPointsToCashError = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].pointsToCashError ?? false;

export const getPointsToCashLoading = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].pointsToCashLoading ?? false;

export const getPointsRedemption = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].pointsRedemption;

export const getPointsRedemptionMaximum = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].pointsRedemption?.maximum;

export const getPointsRedemptionBrackets = (state: CommonStateWithoutValue) =>
  state.context[ParentState.awardsPayment].pointsRedemption?.brackets;

export const getRequiresTravelerRevalidation = (
  state: CommonStateWithoutValue
) => state.context[ParentState.awardsPayment].requiresTravelerRevalidation;
